(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'currencyPairConfiguration'
        })
        
        .controller('ManageCurrencyPairConfigurationController', ManageCurrencyPairConfigurationController);

        ManageCurrencyPairConfigurationController.$inject = ['$scope', '$state', 'workflowSharedService', 'CurrencyPairConfiguration', 'GlobalValues', '$uibModalInstance','EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter','IntradayMarket','MessageBox' ];

    function ManageCurrencyPairConfigurationController($scope, $state, workflowSharedService, CurrencyPairConfiguration, GlobalValues, $uibModalInstance,EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter,IntradayMarket,MessageBox) { 
        var vm = this;   
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_CURRENCY_PAIR_CONFIGURATIONS;
        workflowSharedService.viewFrom = "currencyPairConfiguration";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked=false;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.currencyPairConfigurationfileName = "Currency_Pair_Configuration";
        vm.fileName = vm.currencyPairConfigurationfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.noOfDecimalsForRate = 3;
        vm.getCurrencyConfig = getCurrencyConfig;
        vm.getClearcorpCurrencyConfig = getClearcorpCurrencyConfig;
        vm.onModeChange = onModeChange;
		vm.clear = clear;

        // Default mode for Clearcorp users: 'BANK' (matches original behaviour)
        vm.selectedMode = 'CLEARCORP';
        // MessageBox.openMessageBox("Alert", 'Are you sure to remove the selected instrument?', "YesNo", "continuedeletemktwatch");
        vm.permitCurrencyPairConfigurationViewEntityAction = EntityPermissions.hasPermission('ManageCurrencyPairConfiguration.VIEW')
        vm.permitCurrencyPairConfigurationEditEntityAction = EntityPermissions.hasPermission('ManageCurrencyPairConfiguration.EDIT')

        //get market session settings. to display status. market session settings will be available for SPOT, cash TOM
       	IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);
		
    	function onGetMarketSessionSuccess(result){
        	vm.marketSessionSettings = result;
        }
		
		function onGetMarketSessionFailure(){
			
		}

		if(vm.permitCurrencyPairConfigurationViewEntityAction && vm.entityOwnerType=='Bank'){
			loadAll();	
		}
        
		function loadAll(){
			CurrencyPairConfiguration.getBankCurrencyPairConfiguration({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;                    
            });	
		}

        function getCurrencyConfig(bank){
			CurrencyPairConfiguration.getBankCurrencyPairConfiguration({bankId: bank.id}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;                    
            });	
        }

        function getClearcorpCurrencyConfig(){
            CurrencyPairConfiguration.getAllCurrencyPairConfiguration({}, function(result) {
                vm.currencyPairConfiguration = result;
                vm.clicked=false;
            });
        }

        vm.editConfiguration = function(mode, currencyPair) {
            if (vm.marketSessionSettings && vm.marketSessionSettings.sessionStatus == 'OPEN') {
                MessageBox.openMessageBox("Alert", "Modification is permitted only after the IB.SPOT market hours...!", "Ok", "");
                return;
            }

            if (mode == 'BANK') {
                $state.go('manage-currency-pair-configuration.edit', {
                    labelName: currencyPair.currencyPair.code, 
                    currencyPairConfig: currencyPair, 
                    bankId: currencyPair.bank.id, 
                    bankName: currencyPair.bank.bankName
                });
            } else if (mode == 'CLEARCORP') {
                $state.go('manage-currency-pair-configuration.edit', {
                    labelName: currencyPair.currencyPair.code, 
                    currencyPairConfig: currencyPair, 
                    corpId: vm.globalValues.getCorpId()
                });
            }
        };

        function onModeChange(mode){
            vm.selectedMode = mode;
            vm.currencyPairConfiguration = [];
            vm.bank = null;
            vm.clicked = false;
        }

        function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		
				
		$rootScope.$on('Refresh', function(event, result) {
			loadAll();
		});
		
		logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }   
    }
})();
